/* eslint-disable no-console */
import Keycloak from 'keycloak-js'

const auth = new Keycloak(
  process.env.REACT_APP_ENV === 'development'
    ? '/keycloak-test.json'
    : '/keycloak.json'
)

let authenticated = false

let user = {}

const login = async () => {
  try {
    authenticated = await auth
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false
      })
      .then((authenticated) => {
        return authenticated
      })
      .catch(() => {
        return false
      })

    return authenticated
  } catch (error) {
    return false
  }
}

const getProfile = async () => {
  try {
    await auth
      .loadUserProfile()
      .then((profile) => {
        user = profile
      })
      .catch(() => {
        console.log('Erro inesperado...')
      })

    return user
  } catch (error) {
    return false
  }
}

const getToken = () => {
  return auth.token
}

const isLogged = () => {
  const token = getToken()

  return !!token
}

const refreshToken = async () => {
  try {
    const refreshed = await auth.updateToken(70)

    if (refreshed) {
      console.log('Token renovado com sucesso')

      return true
    }
    return false
  } catch (error) {
    console.error('Erro ao renovar token:', error)

    return false
  }
}

const isTokenExpired = () => {
  if (!auth.token) {
    return true
  }

  try {
    const tokenData = JSON.parse(atob(auth.token.split('.')[1]))
    const currentTime = Math.floor(Date.now() / 1000)

    return tokenData.exp < currentTime
  } catch (error) {
    console.error('Erro ao verificar expiração do token:', error)

    return true
  }
}

const logout = () => {
  auth.logout({
    redirectUri: window.location.origin
  })
}

export {
  getProfile,
  getToken,
  isLogged,
  isTokenExpired,
  login,
  logout,
  refreshToken
}

export default auth
